// extracted by mini-css-extract-plugin
export default {"date-row":"EcomContentFilter_date-row__8Mcvd","btn-get-answer":"EcomContentFilter_btn-get-answer__hV4EQ"};